<template>
	<div class="d-flex flex-row align-items-center justify-content-between px-0">
		<botao-tooltip
			v-if="documento.id"
			data-testid="action-baixar"
			icone="mdi-download"
			cor="grey"
			texto="Baixar Anexo"
			@click="baixarAnexo(documento)"
		></botao-tooltip>
		<botao-tooltip
			v-if="documento.id"
			data-testid="action-excluir"
			icone="mdi-delete"
			cor="grey"
			texto="Excluir Anexo"
			@click="excluirAnexoAdesao(documento)"
		></botao-tooltip>
	</div>
</template>

<script>
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'anexo-adesao-listagem-botoes-acoes',
	components: { BotaoTooltip },
	props: {
		documento: {
			type: Object,
			required: true,
		},
	},
	emits: ['baixar-anexo'],
	methods: {
		async baixarAnexo(anexo) {
			this.$emit('baixar-anexo', {
				idAnexo: anexo.id,
				tipoRegistroDocumento: anexo.tipoRegistroDocumento,
			})
		},
		async excluirAnexoAdesao(anexo) {
			this.$emit('excluir-anexo', {
				idAnexo: anexo.id,
				tipoRegistroDocumento: anexo.tipoRegistroDocumento,
			})
		},
	},
}
</script>

<style scoped></style>
